export default __webpack_public_path__ + "static/media/Financial-support.0dfe2dda.png";